<template>
    <tr>
        <td class="payment">#{{ payment.id }}</td>
        <td class="amount">¥{{ payment.amount | formatNumber }}</td>
        <td class="balance">¥{{ payment.unused_amount | formatNumber }}</td>
        <td class="refund_amount">
            <div class="field paid-amount-field">
                <p class="control used_amount-field is-fullwidth">
                    <input class="input" type="text" v-model="refund_amount">
                </p>
            </div>
        </td>
    </tr>
</template>

<script>

    export default {
        props: ['payment', 'index', 'action'],
        components: {},
        data() {
            return {
                deposit : '',
                //refund_amount: this.action == 'add' ? '' : this.invoice.amount_used,
            }
        },
        methods: {
            depositPayment() {

                //this.$store.commit('setCurrentRefundAmount', this.refund_amount, this.index);
            }
        },
        computed: {
            getCurrency: function () {
                return this.transactionTotals.currency == 2 ? '$' : '¥'
            },
            refund_amount: {
                get: function () {
                    return this.$store.getters.getCurrentRefundAmount.index == this.index ? this.$store.getters.getCurrentRefundAmount.refundAmount : ''
                },
                set: function (value) {
                    if(value > Number(this.payment.unused_amount)){
                        value = Number(this.payment.unused_amount)
                    }
                    this.$store.commit('setCurrentRefundAmount', {'id': this.payment.id, 'index': this.index, 'refundAmount': value});
                }
            }
        }
    }
</script>

<style scoped>
    td {
        font-size: 12px;
    }

    .picture-td {
        width: 65px;
    }

    .link {
        cursor: pointer;
    }

    .image {
        cursor: pointer;
    }
    .used_amount-field {
        max-width: 110px;
    }
    .used_amount_tooltip{
        display: none;
    }
    .error-field .used_amount_tooltip {
        display: block;
        position: absolute;
        width: 169px;
        right: 100%;
        top: 0;
        background-color: #fcf9dc;
        border: 1px solid #ebcc6f;
        border-radius: 3px;
        color: #000;
        padding: 5px 10px;
    }

    .field.paid-amount-field {
        position: relative;
    }
</style>



// WEBPACK FOOTER //
// src/components/Banking/CustomerPaymentTableRow.vue